import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import { useSelector, useDispatch } from "react-redux";

import Select from "react-select";
import DatePicker from "react-datepicker";
import Dropdown from "react-bootstrap/Dropdown";
import { updateJournal } from "../../../Actions/JournalActions/JournalActions";
import { updateApprovalGroup } from "../../../Actions/JournalActions/JournalActions";
const JournalMoreDetailsModal = (props) => {
  const [state, setState] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let { showTalliesTabPane, closeModal, updateJournalSummaryState } = props;
  showTalliesTabPane = showTalliesTabPane
    ? showTalliesTabPane.toLowerCase()
    : "";
  const dispatch = useDispatch();
  const periodOption = () => {
    if (state?.approvalOptions.length > 0) {
      let newArray = [];

      props.state.approvalOptions.map((item) =>
        newArray.push({ value: item.option, label: item.option })
      );
      return newArray;
    }
  };
  const handleChangeType = (data) => {
    setState((prev) => ({
      ...prev,
      approvalGroup: data,
    }));
  };

  const onSave = async (e) => {
    e.preventDefault();

    let journalSummary = {
      approvalGroup: state.approvalGroup.value,
      tran: state.tran,
    };

    setIsLoading(true);

    await dispatch(updateApprovalGroup(journalSummary));

    updateJournalSummaryState();

    let { getJournalList, activeJournal } = props.state;
    let activeJournalToUpdate = getJournalList.find(
      (fi) => fi.id === activeJournal
    );

    await props.getJournal(activeJournalToUpdate, true);
    closeModal("journalMoreDetailOpenModal");

    setIsLoading(false);
  };
  const onChangeHandlerDate = (date) => {
    setState((prev) => ({
      ...prev,
      journalDate: new Date(date).getTime(),
    }));
  };
  const onChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      ...props?.state,
    }));
  }, [props]);

  return (
    <>
      {isLoading ? <div className="se-pre-con"></div> : ""}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={state?.journalMoreDetailOpenModal}
        onHide={() => closeModal("journalMoreDetailOpenModal")}
        className="forgot_email_modal modal_704 mx-auto"
      >
        <Modal.Body>
          <div className="container-fluid ">
            <div className="main_wrapper p-10">
              <div className="row d-flex h-100">
                <div className="col-12 justify-content-center align-self-center form_mx_width">
                  <div className="forgot_form_main">
                    <div className="forgot_header">
                      <div className="modal-top-header">
                        <div className="row bord-btm">
                          <h6 className="text-left def-blue">
                            Journal More Details
                          </h6>
                          <div className="col d-flex justify-content-end s-c-main">
                            <button
                              onClick={onSave}
                              type="button"
                              className="btn-save"
                            >
                              <img
                                src="images/save-check.png"
                                className="mr-2"
                                alt="display-icon"
                              />
                              Save
                            </button>
                            <button
                              onClick={() =>
                                props.closeModal("journalMoreDetailOpenModal")
                              }
                              type="button"
                              className="btn-save"
                            >
                              <img
                                src="images/cancel.png"
                                className="mr-2"
                                alt="display-icon"
                              />
                              Cancel
                            </button>
                            <div className="order-display-main ">
                              <Dropdown
                                alignRight="false"
                                drop="down"
                                className="border-0"
                              >
                                <Dropdown.Toggle id="dropdown-basic-two">
                                  <img
                                    src="images/more.png"
                                    className="img-fluid"
                                    alt="user"
                                  />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    variant="success"
                                    onClick={() => {}}
                                  >
                                    <button
                                      type="button"
                                      className="btn-save def-blue"
                                    >
                                      <img
                                        src="images/display-icon.png"
                                        className="mr-2"
                                        alt="display-icon"
                                      />
                                      Display
                                    </button>
                                  </Dropdown.Item>

                                  {/* <Dropdown.Item variant="success">
                                    <button
                                      onClick={() => {}}
                                      type="button"
                                      className="btn-save def-blue"
                                    >
                                      <img
                                        src="images/save-check.png"
                                        className="mr-2"
                                        alt="display-icon"
                                      />
                                      Save
                                    </button>
                                  </Dropdown.Item> */}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="forget-body">
                      <div className="row mt-4">
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>Tran</label>
                            <div className="modal_input">
                              <input
                                name="tran"
                                type="text"
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : "form-control"
                                }
                                id="j-tran"
                                value={state?.tran || ""}
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandler
                                    : null
                                }
                                disabled={showTalliesTabPane !== "draft"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" col-12">
                          <div className="form-group custon_select">
                            <label htmlFor="id_dt">Date</label>
                            <div className="modal_input datePickerUP">
                              <DatePicker
                                name="poDate"
                                // id="periodEndingDate"
                                tabIndex="3334"
                                dateFormat="d MMM yyyy"
                                autoComplete="off"
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandlerDate
                                    : null
                                }
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : ""
                                }
                                disabled={showTalliesTabPane !== "draft"}
                                selected={state?.journalDate || ""}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>Description</label>
                            <div className="modal_input">
                              <input
                                name="description"
                                type="text"
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : "form-control"
                                }
                                id="jdesc"
                                value={state?.description || ""}
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandler
                                    : null
                                }
                                disabled={showTalliesTabPane !== "draft"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>Approval Group</label>
                            <Select
                              className={
                                showTalliesTabPane !== "draft"
                                  ? "disable_bg disable_border"
                                  : "width-selector"
                              }
                              value={state?.approvalGroup}
                              classNamePrefix="custon_select-selector-inner"
                              options={periodOption()}
                              onChange={(e) =>
                                showTalliesTabPane === "draft"
                                  ? handleChangeType(e)
                                  : () => {}
                              }
                              isDisabled={showTalliesTabPane !== "draft"}
                              theme={(theme) => ({
                                ...theme,
                                border: 0,
                                borderRadius: 0,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#f2f2f2",
                                  primary: "#f2f2f2",
                                },
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>User Name</label>
                            <div className="modal_input">
                              <input
                                name="UserName"
                                type="text"
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : "form-control"
                                }
                                id="userrname"
                                value={state?.UserName || ""}
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandler
                                    : null
                                }
                                disabled={showTalliesTabPane !== "draft"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>Batch</label>
                            <div className="modal_input">
                              <input
                                name="batch"
                                type="text"
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : "form-control"
                                }
                                id="j-btch"
                                value={state?.batch || ""}
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandler
                                    : null
                                }
                                disabled={showTalliesTabPane !== "draft"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="form-group custon_select">
                            <label>Voucher</label>
                            <div className="modal_input">
                              <input
                                name="voucher"
                                type="text"
                                className={
                                  showTalliesTabPane !== "draft"
                                    ? "disable_bg disable_border"
                                    : "form-control"
                                }
                                id="jvoucher"
                                value={state?.voucher || ""}
                                onChange={
                                  showTalliesTabPane === "draft"
                                    ? onChangeHandler
                                    : null
                                }
                                disabled={showTalliesTabPane !== "draft"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default JournalMoreDetailsModal;
